module.exports = __webpack_public_path__ + "rotary_slight_left.svg?916599fbe79fbfe3899f1857e63bbc2a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/diving_icons/rotary_slight_left.svg
// module id = 212
// module chunks = 0